<template>
  <button
    :class="classes"
    @click="$emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'gray',
    },
  },
  computed: {
    classes () {
      const { color } = this
      return [`border-${color}-500 hover:border-${color}-600 text-${color} border py-1 px-1 uppercase text-sm`]
    },
  },
}
</script>
